export * from './eab-nav-settings-permissions.js'; // TODO: remove this .js extension
export * from './eab-nav-entity-viewer-list-form.js'; // TODO: remove this .js extension

export class NavViewTemplates {
  readonly id = 'nav/view-templates/index';
  readonly crate = 'nav/view-templates';
  readonly ns = 'nav';
}

export default new NavViewTemplates();
